import { render } from "./ArcadeHome.vue?vue&type=template&id=08a40ad6&scoped=true"
import script from "./ArcadeHome.vue?vue&type=script&lang=js"
export * from "./ArcadeHome.vue?vue&type=script&lang=js"

import "./ArcadeHome.vue?vue&type=style&index=0&id=08a40ad6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08a40ad6"]])

export default __exports__